import { ArrowDown, ArrowUp, X } from "lucide-react";
import { Link } from "react-router-dom";

export const BundleItems = ({ b, products, onSave }) => {
  const ids = b.items.map((i) => i.id);
  const move = (i, d) => {
    const next = [...ids];
    [next[i], next[i + d]] = [next[i + d], next[i]];
    onSave({ product_ids: next });
  };
  const others = products.filter((p) => !ids.includes(p.id));

  return (
    <div className="border border-[#2A2325]/10 bg-[#FFFDF9] p-6" data-testid="bundle-items">
      <div className="eyebrow mb-3">{b.kind === "series" ? "Every title in this category" : "Titles in this bundle"}</div>
      <ol className="divide-y divide-[#2A2325]/10">
        {b.items.map((it, i) => (
          <li key={it.id} className="flex items-center gap-3 py-2.5" data-testid={`bundle-item-${it.id}`}>
            <span className="font-display italic text-[#9A6B2F] w-6">{i + 1}</span>
            <Link to={`/products/${it.id}`} className="flex-1 hover:underline">
              {it.title}
              <span className="block text-xs text-[#5C5255]">
                {it.product_type} · {it.price ? `A$${it.price}` : "no price"}{it.page_count ? ` · ${it.page_count} pages` : ""}
              </span>
            </Link>
            {!it.ready && <span className="text-[10px] tracking-widest text-[#9A6B2F]" data-testid={`bundle-item-not-built-${it.id}`}>NOT BUILT</span>}
            {b.kind === "pair" && (
              <div className="flex gap-1">
                <button disabled={!i} onClick={() => move(i, -1)} className="p-1 disabled:opacity-30" aria-label="Move up" data-testid={`bundle-item-up-${it.id}`}><ArrowUp size={14} /></button>
                <button disabled={i === ids.length - 1} onClick={() => move(i, 1)} className="p-1 disabled:opacity-30" aria-label="Move down" data-testid={`bundle-item-down-${it.id}`}><ArrowDown size={14} /></button>
                <button disabled={ids.length <= 2} onClick={() => onSave({ product_ids: ids.filter((x) => x !== it.id) })} className="p-1 disabled:opacity-30" aria-label="Remove" data-testid={`bundle-item-remove-${it.id}`}><X size={14} /></button>
              </div>
            )}
          </li>
        ))}
      </ol>
      {b.kind === "pair" && others.length > 0 && (
        <select value="" onChange={(e) => e.target.value && onSave({ product_ids: [...ids, e.target.value] })} className="mt-3 w-full h-9 border border-[#2A2325]/20 bg-white px-2 text-sm" data-testid="bundle-add-select">
          <option value="">Add a title…</option>
          {others.map((p) => <option key={p.id} value={p.id}>{p.title}</option>)}
        </select>
      )}
      {b.unbuilt > 0 && <p className="text-xs bg-[#F3E5AB]/60 px-3 py-2 mt-3" data-testid="bundle-unbuilt-note">{b.unbuilt} title{b.unbuilt > 1 ? "s aren't" : " isn't"} built yet, so {b.unbuilt > 1 ? "they're" : "it's"} left out of the bundle PDF. Build {b.unbuilt > 1 ? "them" : "it"} in the Studio, then rebuild the bundle.</p>}
      {b.kind === "series" && <p className="text-xs text-[#5C5255] mt-3">New titles in this category join automatically. When a title goes live on softspinepress.com, a published series bundle is re-sent with it.</p>}
    </div>
  );
};
